import { Injectable } from '@angular/core';
import { HttpProvider } from '../http/http';

/*
  Generated class for the GroupProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class GroupProvider {
  constructor(public http: HttpProvider) {
    console.log('Hello GroupProvider Provider');
  }

  addGroup(new_group_name) {
    return this.http.hPost('/group/add_group', { new_group_name: new_group_name });
  }

  quitChatroom(chatroomname){
    return this.http.hPost('/group/quit_chatroom', { chatroomname: chatroomname });
  }


  getGroupList() {
    let url = '/group/get_group_list';
    return this.http.hPost(url, {get_child: 1});
  }

  transferChatroom(chatroom_id,origin_group_id,target_group_id) {
    let params = {
      chatroomname: chatroom_id,
      old_group_id:origin_group_id,
      new_group_id: target_group_id,
    };
    return this.http.hPost('/group/transfer_chatroom_into_group', params);
  }

  removeGroup(group_id) {
    let params = {
      group_id: group_id,
    };
    return this.http.hPost('/group/delete_a_group', params);
  }
  renameGroup(group_id, new_group_name) {
    let params = {
      group_id: group_id,
      new_group_name: new_group_name,
    };
    return this.http.hPost('/group/rename_a_group', params);
  }

  getMembersByChatroomname(chatroomname) {
    let params = {
      chatroomname: chatroomname
    };
    return this.http.hPost('/group/get_members_by_chatroomname', params)
  }

  transferRoomowner(chatroomname, username) {
    let params = {
      chatroomname: chatroomname,
      member_username: username
    };
    return this.http.hPost('/group/transfer_roomowner', params)
  }

  activateChatroom(chatroomname){
    let params = {
      chatroomname: chatroomname,
    };
    return this.http.hPost('/group/activate_chatroom', params)
  }
}



// WEBPACK FOOTER //
// ./src/providers/group/group.ts